import { useState } from "react";

import { AcquirerCopyForm } from "src/app/features/Acquirer/components/forms/AcquirerCopyForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const AcquirerCopyFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.acquirersCopyFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.ACQUIRER}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AcquirerCopyForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
